export default "__VITE_ASSET__DFfBicQr__"